import { Component, computed, inject, input } from '@angular/core';
import { LayoutService } from '../../core/services/layout.service';
import { IconComponent } from "../icons/icon.component";
import { IconNameType } from '../icons/icon-name-type.enum';
import { ModalName, ModalService } from '../../core/services/modal.service';

@Component({
   selector: 'cwo-store-info',
   standalone: true,
   imports: [IconComponent],
   templateUrl: './store-info.component.html',
   styleUrl: './store-info.component.scss'
})
export class StoreInfoComponent {
   private layout = inject(LayoutService);
   private modalService = inject(ModalService);

   public iconName = IconNameType;

   public storeLabel = input.required<string>();
   public storePhoneNumber = input.required<string>();

   public viewportState = computed(() => this.layout.state());

   public onStoreInfoClick(): void {
      this.openStoreSelectionModal();
   }

   private openStoreSelectionModal(): void {
      this.modalService.closeAllModals().subscribe(
         () => {
            this.modalService.openModal(ModalName.OrderDetails, {
               showStoreChooser: true,
            });
         });
   }
}
